import React from 'react';

const AboutValues: React.FC = () => (
  <section className="bg-white py-24 md:py-32">
    <div className="container-main grid md:grid-cols-12 gap-8 md:gap-16 items-start">
      <div className="md:col-span-4 lg:col-span-3">
        <h2 className="text-[#2980b9] font-bold text-xl tracking-widest uppercase">Our Values</h2>
      </div>
      <div className="md:col-span-8 lg:col-span-7">
        <ul className="space-y-4 text-gray-600 text-lg md:text-xl font-light leading-relaxed">
          <li className="flex gap-4">
            <span className="text-gray-400">—</span>
            <span>Every product meets CE and FDA standards before it reaches our customers.</span>
          </li>
          <li className="flex gap-4">
            <span className="text-gray-400">—</span>
            <span>We stay current with the latest medical technologies and applications.</span>
          </li>
          <li className="flex gap-4">
            <span className="text-gray-400">—</span>
            <span>Exporting to any country in Africa with reliable logistics and support.</span>
          </li>
          <li className="flex gap-4">
            <span className="text-gray-400">—</span>
            <span>We give back to the communities that support us, primarily through youth initiatives.</span>
          </li>
        </ul>
      </div>
    </div>
  </section>
);

export default AboutValues;
